import React from 'react';
import { useDropzone } from 'react-dropzone';
import '../styles/DropzoneArea.css';
import useFileUpload from '../api/fileUpload';
import { useNavigate } from "react-router-dom";



const DropzoneArea = ({setToasts, container_name}) => {
    
    const navigate = useNavigate();
    const { uploadFiles } = useFileUpload(navigate, container_name);
    // Restrict file types and size
    const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
    const acceptedFileTypes = {
        'application/pdf': ['.pdf'],
        'image/jpeg': ['.jpeg', '.jpg'],
        'image/png': ['.png']
    };

    const onDrop = async (acceptedFiles) => {
        // Filter files by type and size
        const validFiles = acceptedFiles.filter(
        (file) =>
            Object.keys(acceptedFileTypes).includes(file.type) &&
            file.size <= maxSize
        );

    const invalidFiles = acceptedFiles.filter(
        (file) =>
        !Object.keys(acceptedFileTypes).includes(file.type) ||
        file.size > maxSize
    );

    if (invalidFiles.length > 0) {
        alert(
          `Some files were not accepted:\n${invalidFiles
            .map(
              (file) =>
                `${file.name} - ${
                  !Object.keys(acceptedFileTypes).includes(file.type)
                    ? 'Invalid file type'
                    : 'Exceeds size limit of 5MB'
                }`
            )
            .join('\n')}`
        );
      }  

    if (validFiles.length > 0) {
        const toastId = Date.now();
        console.log('Valid files:', validFiles);
        // Add a new toast
        setToasts((prev) => [
            ...prev,
            { id: toastId, label: "Uploading Files", progress: 0 },
        ]);
        try {
            console.log("Uploading files...");
            await uploadFiles(
                validFiles,
                (progress) => {
                    // Update progress in the toast
                    setToasts((prev) =>
                        prev.map((toast) =>
                            toast.id === toastId ? { ...toast, progress } : toast
                        )
                    );
                },
                10 // Batch size
            );
            setToasts((prev) =>
              prev.map((toast) =>
                toast.id === toastId ? { ...toast, progress: 100 } : toast
              )
            );
        } catch (error) {
            // Mark the toast with an error message
          setToasts((prev) =>
            prev.map((toast) =>
              toast.id === toastId
                ? { ...toast, label: "Error downloading files", progress: 0 }
                : toast
            )
          );
        }
    }
  };

  const {
    getRootProps,
    getInputProps,
    isDragActive
  } = useDropzone({
    onDrop,
    accept: acceptedFileTypes,
  });

  return (
    <div
      {...getRootProps()}
      className={`dropzone ${isDragActive ? 'active' : ''}`}
    >
      <input
        {...getInputProps()}
        webkitdirectory="true" // Enables folder selection
        directory="true" // Ensures cross-browser support
      />
      {isDragActive ? (
        <p>Drop the files here...</p>
      ) : (
        <p>Drag and drop some files here, or click to select files</p>
      )}
    </div>
  );
};

export default DropzoneArea;
